import { query } from '@confluence/query-preloader-tools/entry-points/graphql';

import { getLicensedProductsQuery } from './getLicensedProductsQuery';

export const preloadGetLicensedProductsQuery = () => {
	return query({
		/* @ts-expect-error -- http://go/cfe-use-relay-artifacts */
		query: getLicensedProductsQuery(),
	});
};
